import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { createPortal } from "react-dom";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import Deposit from "../transactions/Deposit";
import LoginGlobal from "../data/LoginGlobal";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function BirthdayBonus({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData, isPromotionDataReady } = usePromotionsData();
	const data = promotionsData.find((promo) => promo.title === "Birthday Bonus");
	const [isMobile, setIsMobile] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [isDepositOpen, setIsDepositOpen] = useState(false);
	const navigate = useNavigate();
	
	useEffect(() => {
		const loggedInState = localStorage.getItem("isLoggedIn") === "true";
		setIsLoggedIn(loggedInState);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (!isDepositOpen) return;
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = prev;
		};
	}, [isDepositOpen]);

	// Table Data Incase
	const tableData = [
		{
			vipTier: "Alexandrite",
			bonus: "₱2,000",
		},
		{
			vipTier: "Diamond",
			bonus: "₱1,000",
		},
		{
			vipTier: "Ruby",
			bonus: "₱750",
		},
		{
			vipTier: "Sapphire",
			bonus: "₱500",
		},
		{
			vipTier: "Emerald",
			bonus: "₱250",
		},
	];

	// If the promo page is expired - throws error
	useEffect(() => {
		if (!isPromotionDataReady) return;

		if (!data) {
			navigate("/not-found");
		}
	}, [isPromotionDataReady, data, navigate]);

	if (!isPromotionDataReady || !data) return null;

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Birthday Bonus</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions{" "}
							</a>{" "}
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH ${data.title}`}
							/>
						</div>
						<div className="promotion-tnc-content">
							<div className="promotion-tnc-info">
								<div
									className={`promotion-indication-message ${data.promotionMessage.class}`}
								>
									{data.promotionMessage.text}
								</div>
								<h1>Birthday Bonus</h1>
								<h2>Get up to ₱2,000 credits</h2>
								<div className="promotion-tnc-period">
									<strong>Promo Period: </strong>
									<span>Seasonal</span>
								</div>
							</div>
							<div className="promotion-tnc-mechanic-content">
								<div className="table-wrapper">
									<table
										className="promotion-tnc-table"
										style={{ minWidth: "0px" }}
									>
										<thead>
											<th>VIP Tier</th>
											<th>Bonus</th>
										</thead>
										<tbody>
											{tableData.map((row, index) => (
												<tr key={index}>
													<td>{row.vipTier}</td>
													<td>{row.bonus}</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>

								<strong>Terms & Conditions:</strong>
								<ol>
									<li>
										<p>
											Birthday Bonus is based on player's current VIP LEVEL.
										</p>
									</li>
									<li>
										<p>
											Players must have at least 5 successful deposits prior to
											their birthday month to qualify for the bonus.
										</p>
										<p>
											<span className="promotion-tnc-block-text">
												(Example : Your Birthday is October 2024 {" >> "} Our
												Support will verify if you have successfully deposited
												at least 5 times in the month of September 2024.)
											</span>
										</p>
									</li>
									<li>
										<p>
											We will require a valid ID during verification (manual
											process).
										</p>
									</li>
									<li>
										<p>
											Birthday bonus is credited as bonus money and needs to be
											wagered 3X before withdrawal.
										</p>
									</li>
									<li>
										<p>
											FGH reserves the right to change, suspend or cancel the
											promotion at any time.
										</p>
									</li>
								</ol>
								{!isAppPromo && (
									<>
										<div className="promotion-tnc-cta">
											{isLoggedIn ? (
												<button
													type="button"
													className="promotion-cta-btn"
													style={{ cursor: "pointer" }}
													onClick={() => setIsDepositOpen(true)}
												>
													Claim your gift
												</button>
											) : (
												<LoginGlobal
													label="Claim your gift"
													btnClass="promotion-cta-btn"
													onlyBtn={true}
												/>
											)}
										</div>
										{isDepositOpen &&
											createPortal(
												<div className="modal-portal">
													<Deposit
														onClose={() => setIsDepositOpen(false)}
														defaultBonusName="New Member Package Bonus"
													/>
												</div>,
												document.body,
											)}
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
